export const InviteError: React.FC = ({ children }) => {
  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-center font-serif text-2xl font-bold text-dm-brand-blue-600">
        Error
      </h1>
      <div className="flex flex-col gap-4 text-center text-dm-brand-blue-800">
        {children}
      </div>
    </div>
  );
};
